document.addEventListener("DOMContentLoaded", function () {
    function startBotTrapCheck() {
        var botInput = document.querySelector("#bot_trap");
        var btns = document.querySelector(".product-form__btns");

        if (!botInput || !btns) {
            setTimeout(startBotTrapCheck, 300);
            return;
        }

        function checkBotTrap() {
            // Agar sessionStorage me flag already hai → direct hide
            if (sessionStorage.getItem("botTrapTriggered") === "true") {
                btns.style.display = "none";
                return;
            }

            if (botInput.value && botInput.value.trim() !== "") {
                // Ek baar trigger hone par session me save
                sessionStorage.setItem("botTrapTriggered", "true");
                btns.style.display = "none";
                console.log("🚫 Bot trap triggered → product-form__btns permanently hidden (session)");
            } else {
                btns.style.display = ""; // Only show if not triggered
            }
        }

        checkBotTrap();
        botInput.addEventListener("input", checkBotTrap);

        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "value") {
                    const newVal = botInput.getAttribute("value") || "";
                    botInput.value = newVal;
                    checkBotTrap();
                }
            });
        });

        observer.observe(botInput, { attributes: true });
        setInterval(checkBotTrap, 500);
    }

    startBotTrapCheck();
});
